<mat-toolbar [class.on-hero]="isHome()" [class.on-page]="!isHome()">
  <a routerLink="/" class="logo-link">
    <img src="icons/logo.png" alt="logo" class="logo" />
  </a>
  <span class="spacer"></span>
  <nav>
    <a mat-button routerLink="/" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }">Générateur Slides</a>
    <a mat-button routerLink="/slides-ac" routerLinkActive="active-link">Slides AC</a>
    <a mat-button routerLink="/slides-vt" routerLinkActive="active-link">Slides VT</a>
  </nav>
</mat-toolbar>
